var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPowerActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4317_251526)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1285 0.169514C28.631 0.461809 28.8657 1.06199 28.6948 1.61765L24.1925 16.25H32.5C32.9987 16.25 33.4497 16.5465 33.6475 17.0042C33.8453 17.462 33.7521 17.9936 33.4103 18.3567L13.4103 39.6067C13.0118 40.0301 12.3741 40.1229 11.8716 39.8306C11.369 39.5383 11.1343 38.9381 11.3053 38.3824L15.8076 23.75H7.50003C7.00133 23.75 6.55036 23.4536 6.35256 22.9958C6.15476 22.538 6.24799 22.0065 6.58978 21.6433L26.5898 0.393333C26.9882 -0.0300184 27.6259 -0.12278 28.1285 0.169514ZM10.3931 21.25H17.5C17.8967 21.25 18.2698 21.4383 18.5055 21.7574C18.7412 22.0765 18.8114 22.4885 18.6948 22.8676L15.2769 33.9758L29.607 18.75H22.5C22.1033 18.75 21.7302 18.5618 21.4945 18.2427C21.2589 17.9236 21.1886 17.5116 21.3053 17.1324L24.7232 6.02426L10.3931 21.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4317_251526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPowerActive);
export default __webpack_public_path__ + "static/media/ic-power-active.8e04c359.svg";
export { ForwardRef as ReactComponent };